import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgDotEcryption = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M7.782 5.22852H16.217C19.165 5.22852 21 7.30949 21 10.2555V14.3105C21 17.2555 19.165 19.3365 16.216 19.3365H7.782C4.834 19.3365 3 17.2555 3 14.3105V10.2555C3 7.30949 4.843 5.22852 7.782 5.22852Z",
			stroke: "#000000",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M11.9992 12.2262V12.1622V12.2262ZM11.7402 12.2122C11.7402 12.0682 11.8562 11.9512 12.0002 11.9512C12.1442 11.9512 12.2612 12.0682 12.2612 12.2122C12.2612 12.3562 12.1442 12.4732 12.0002 12.4732C11.8562 12.4732 11.7402 12.3562 11.7402 12.2122Z",
			stroke: "#000000",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M15.9035 12.2262V12.1622V12.2262ZM15.6445 12.2122C15.6445 12.0682 15.7615 11.9512 15.9055 11.9512C16.0495 11.9512 16.1655 12.0682 16.1655 12.2122C16.1655 12.3562 16.0495 12.4732 15.9055 12.4732C15.7615 12.4732 15.6445 12.3562 15.6445 12.2122Z",
			stroke: "#000000",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M8.09399 12.2262V12.1622V12.2262ZM7.83398 12.2122C7.83398 12.0682 7.95099 11.9512 8.09499 11.9512C8.23899 11.9512 8.35599 12.0682 8.35599 12.2122C8.35599 12.3562 8.23899 12.4732 8.09499 12.4732C7.95099 12.4732 7.83398 12.3562 7.83398 12.2122Z",
			stroke: "#000000",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
export default SvgDotEcryption;
